// Per-user cache of geocoded company addresses (FE #751).
//
// Google Maps Platform Service Specific Terms §6.3 allow caching Geocoding API
// lat/lng for at most 30 consecutive days, and only per end user. That is why
// the cache lives in this browser's localStorage and is never sent to our
// backend. Every storage access is guarded: private windows and blocked site
// data make localStorage throw, and the map must still render.

export const GEOCODE_CACHE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
const KEY_PREFIX = "alphasearch.geocode.v1:";

function cacheKey(address) {
  const normalized = String(address || "").trim().toLowerCase().replace(/\s+/g, " ");
  return normalized ? KEY_PREFIX + normalized : null;
}

function removeQuietly(key) {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Storage unavailable; nothing to clean up.
  }
}

export function readGeocodeCache(address, now = Date.now()) {
  const key = cacheKey(address);
  if (!key) return null;
  let entry;
  try {
    entry = JSON.parse(window.localStorage.getItem(key));
  } catch {
    return null;
  }
  if (!entry || !Number.isFinite(entry.lat) || !Number.isFinite(entry.lng) || !Number.isFinite(entry.t)) {
    return null;
  }
  if (now - entry.t > GEOCODE_CACHE_TTL_MS) {
    removeQuietly(key);
    return null;
  }
  return { lat: entry.lat, lng: entry.lng };
}

export function writeGeocodeCache(address, point, now = Date.now()) {
  const key = cacheKey(address);
  if (!key) return;
  try {
    window.localStorage.setItem(key, JSON.stringify({ lat: point.lat, lng: point.lng, t: now }));
  } catch {
    // Quota exceeded or storage blocked; the map still renders uncached.
  }
}
